module.exports = __webpack_public_path__ + "static/media/logo_.1eace128.png";